import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'styles/pages/Benefits/ShippingLeads/ShippingLeads.module.scss';

const cn = classNames.bind(styles);

const SectionCallToAction = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  const renderCtaTextContentByScreenWidth = () => {
    if (screenWidth >= 576) {
      return (
        <p className={cn('cta__text')}>
          <span>Ensure your freight business stays ahead in an increasingly</span>
          <span>competitive market by turning shipping leads</span>
          <span>into sustainable growth opportunities.</span>  
        </p>
      );
    } else {
      return (
        <p className={cn('cta__text')}>
          Ensure your freight business stays ahead in an increasinglycompetitive market by 
          turning shipping leads into sustainable growth opportunities.
        </p>
      );
    }
  };

  return (
    <section className={cn('cta')}>
      <div className={cn('container')}>
        <div className={cn('cta__content')}>
          {renderCtaTextContentByScreenWidth()}
          <div className={cn('cta__buttons')}>
            <Link className={cn('cta__button-join')} href="/membership">
              Join Us Now
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionCallToAction;